import cx from 'classnames';
import { isEmpty } from "lodash";
import { useState } from "react";
import { CheckboxV2 } from '../../../../common/CheckboxV2/CheckboxV2';
import ArrowDownIconV2 from '../../../icons/ArrowDownIconV2';
import styles from './FilterSubmenu.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { selectSavedFiltersData, setDoFilterUpdateValue } from '../../../../redux/slicers/admin/sidebarSlicer';
import { parseSidefilterParams } from '../../../../api/apiGenerator';
import { updateFiltersInRedux } from '../../../SideFilter/SideFilter';
import { getSidefilters } from '../../../../helpers/api';
import { paginatedProductSelectors } from '../../../../redux/slicers/admin/paginatedProductSlicer';
import { MODEL_TYPES } from '../../../../constants/constants';

export const FilterSubmenu = ({ filters, maxVisible = 6, value, onChange, version, v2, showSubCategories }) => {
  const isV2 = version === '2';

  const hideFilterSection = (value) => {
    const hideSectionName = ['room scene', ...(!showSubCategories ? ['sub category', 'sub categories'] : [])];
    const filterValue = value?.filter(({title})=> !title || !hideSectionName?.includes(title?.trim?.()?.toLowerCase?.()))
    return filterValue || []
  }
  
  return (
    <div className={cx(styles.filterSubmenu, isV2 && styles.v2)}>
      {hideFilterSection(filters)?.map((filter, idx) => {
        const { title, items, key } = filter;
        
        return (
          <FilterItem
            key={idx}
            keyPrefix={key}
            title={title}
            items={items}
            value={value}
            onChange={onChange}
            maxVisible={maxVisible}
            version={version}
            v2={v2}
          />
        );
      })}
    </div>
  );
};

const FilterItem = ({ title, keyPrefix, items, maxVisible, value, onChange, version, v2 }) => {
  const [open, setOpen] = useState(false);
  const isV2 = version === '2';
  const dispatch = useDispatch();
  const savedFilters = useSelector(selectSavedFiltersData);
  const [showOnlyMaxvisible, setShowOnlyMaxVisible] = useState(true);
  const [maxVisibleLocal, setMaxVisibleLocal] = useState(maxVisible);
  
  const pageSearch = useSelector(paginatedProductSelectors.selectSearch);
  if (isEmpty(items)) return null;
  let keyToCheck;
  if (isNaN(keyPrefix)) {
    keyToCheck = keyPrefix + 's';
  } else {
    keyToCheck = title + '_' + keyPrefix;
  }

  const objectToOperate = savedFilters?.otherDetails?.[keyToCheck];
  let moreCount = items.length - maxVisibleLocal;
  if (v2) {
    moreCount = objectToOperate?.total - (showOnlyMaxvisible ? maxVisible: items?.length);
  }

  const visibleItems = moreCount > 0 && !open ? items.slice(0, maxVisible) : items;

  const getPageNumber = () => {
    if (!objectToOperate?.total) return 1;
    return objectToOperate?.total_pages > objectToOperate?.page ? objectToOperate?.page + 1 : objectToOperate?.page;
  };

  const createViewMoreFunction = async ({ title, type, page = 1, labelId } = {}) => {
    let typeToPass;
    if (isNaN(type)) {
      typeToPass = `${type}s`;
    } else {
      typeToPass = 'filterOptions';
      // let allFilterLabelKeys = savedFilters['filterlabels'].map((data) => data.id);
      // if (allFilterLabelKeys?.includes(type)) {
      //   typeToPass = 'filterLabels';
      // }
    }
    // Generate parameters for the side filter API call
    const searchParams = new URLSearchParams(window.location.search);
    let params = parseSidefilterParams({ searchParams, type: typeToPass, page, labelId });
    const modelType = MODEL_TYPES.PRODUCT;

    // Make the API call to get side filters
    if (pageSearch && typeof pageSearch === 'string') {
      params = params + `&item_search=${pageSearch}`; // item_search -> has the value of the search from the page search
    }
    const response = await getSidefilters({ params: params, type: typeToPass, modelType });
    const copyResponse = JSON.parse(JSON.stringify(response));

    if (copyResponse && copyResponse.results) {
      // Update filters in Redux based on the type and labelId
      updateFiltersInRedux({
        type: labelId && !isNaN(labelId) ? `${title}_${labelId}` : (type + 's'),
        response: copyResponse,
        updateInSelector: true
      });
    }
  };

  const onChangeLocal = (value, e) => {
    if (v2) {
      dispatch(setDoFilterUpdateValue(true));
    }
    onChange(value, e)
  }

  const setOpenLocal = (val, count) => {
    if (v2) {
      if (val && count <= 0) {
        setShowOnlyMaxVisible(true);
        setOpen(false);
      } else {
        setOpen(true)
        setShowOnlyMaxVisible(false);
        if (objectToOperate?.total_pages > objectToOperate?.page) {
          createViewMoreFunction({ title, type: keyPrefix, page: getPageNumber(), labelId: keyPrefix })
        }
      }
    } else {
      setOpen(!open);
      if (!open) {
        setMaxVisibleLocal(items.length);
      } else {
        setMaxVisibleLocal(maxVisible);
      }
    }
  }

  return (
    <div className={cx('filter-checkbox')}>
      {title && (
        <div className={styles.title}>
          <h5>{title}</h5>
        </div>
      )}

      {visibleItems.map((item, idx) => {
        const label = `${item.label.charAt(0).toUpperCase()}${item.label.slice(1).toLowerCase()}`
        const id = `curatorFilter__${keyPrefix || 'default'}__${item.value}`

        const checkboxProps = {
          id,
          name: item.name,
          value: item.value,
          checked: value.includes(item.value),
          onChange: (e)=> onChangeLocal(item.value, e)
        }

        if (isV2) {
          return (
            <div className={styles.checkboxContainer}>
              <CheckboxV2
                label={label}
                elipsis
                containerClassName="w-100"
                {...checkboxProps}
              />
            </div>
          )
        }

        return (
          <div className="form-check custom-checkbox" key={`visibleFilterItem${idx}`}>
            <input
              className="form-check-input"
              type="checkbox"
              {...checkboxProps}
            />
            <label className="form-check-label" htmlFor={id}>
              {label}
            </label>
          </div>
        );
      })}

      {
        ((moreCount > 0) || (open && moreCount <= 0)) && <div className={cx('more', styles.more, open && styles.moreOpen)} onClick={() => setOpenLocal(open, moreCount)}>
          <span>
            {(moreCount > 0) && `${moreCount} more`}
            {(open && moreCount <= 0) && 'Show less'}
          </span>

          {isV2 && <ArrowDownIconV2 className={styles.arrow} />}
        </div>
      }
    </div>
  );
};
